module.exports = __webpack_public_path__ + "static/media/recorders1.67345211.jpg";